import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share"

export default function SocialMediaButtons({
  url,
  title,
  summary,
  twitterVia,
  linkedInSource,
}) {
  return (
    <>
      <div className="socials pt-2 pb-2">
        <ul>
          <li>
            <TwitterShareButton url={url} title={title} via={twitterVia}>
              <StaticImage src="../../images/ico-twitter.svg" alt="" />
            </TwitterShareButton>
          </li>

          <li>
            <LinkedinShareButton
              title={title}
              url={url}
              summary={summary}
              source={linkedInSource}
            >
              <StaticImage src="../../images/ico-linkedin.svg" alt="" />
            </LinkedinShareButton>
          </li>
          <li>
            <FacebookShareButton url={url} quote={title}>
              <StaticImage src="../../images/ico-facebook.svg" alt="" />
            </FacebookShareButton>
          </li>
        </ul>
      </div>

      {/* <WhatsappShareButton
        url={"http://www.camperstribe.com"}
        title={"Title"}
        separator={" "}
      >
        <WhatsappIcon size={36} />
      </WhatsappShareButton> */}

      {/* <EmailShareButton
        url={"http://www.camperstribe.com"}
        subject={"CampersTribe - World is yours to explore"}
        body=""
      >
        <EmailIcon size={36} />
      </EmailShareButton> */}
    </>
  )
}
